var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("generic-modal", {
    ref: "bulkRequestModal",
    attrs: {
      id: "bulk-request-modal",
      "body-class": _vm.modalBodyClass,
      "modal-dialog-size": "lg",
      "modal-footer": !_vm.loadingInitialData,
      "loaders-disabled": "",
      "no-enforce-focus": true,
    },
    on: { show: _vm.handleShow, hidden: _vm.handleHidden },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [
            _vm._v("\n    " + _vm._s(_vm.currentStepTitle) + "\n    "),
            _vm.currentStepRenderingInfo.component ===
            "request-bank-statements-step"
              ? _c(
                  "span",
                  { attrs: { id: "filogix-sync-tooltip" } },
                  [
                    _c("icon", {
                      staticClass: "tooltip-info",
                      attrs: { name: "question-circle" },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ]
        },
        proxy: true,
      },
      {
        key: "body",
        fn: function () {
          return [
            _vm.accountPlanPage
              ? _c("account-usage-banner", {
                  attrs: {
                    page: _vm.accountPlanPage,
                    "position-fixed": false,
                    "side-right": false,
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.loadingInitialData
              ? _c("bulk-request-modal-loader")
              : _c(_vm.currentStepRenderingInfo.component, {
                  key: _vm.currentStepRenderingInfo.dataKey,
                  ref: "component",
                  tag: "component",
                  attrs: {
                    "client-request-email": _vm.clientRequestEmail,
                    "current-application": _vm.CURRENT_APPLICATION,
                    "client-email": _vm.stepsData.emailToSend,
                    "include-request-documents":
                      _vm.computedStepsRendering.requestDocuments
                        .includedInPath,
                    "include-request-bank-statements":
                      _vm.computedStepsRendering.requestBankStatements
                        .includedInPath,
                    "include-send-application": _vm.includeSendApplication,
                    "documents-classifications": _vm.documentClassifications,
                    "include-bank-statements": _vm.includeBankStatements,
                    "selected-classifications":
                      _vm.stepsData.documentRequestIds,
                    applicants: _vm.applicants,
                    "selected-applicants":
                      _vm.selectedApplicantsByDocumentRequestIds,
                    "bank-statements-requests": _vm.stepsData.bankStatements,
                    "user-message": _vm.stepsData.userMessage,
                    "document-request-templates": _vm.documentRequestTemplates,
                    "auto-selected-email-template":
                      _vm.autoSelectedEmailTemplate,
                    "user-details": _vm.userDetails,
                    loading: _vm.loading,
                    "check-for-erros": _vm.errorsChecked,
                    "account-is-ghost": _vm.accountIsGhost,
                    "preview-email": _vm.previewEmail,
                    "application-details": _vm.applicationDetails,
                    "previous-requested-packages":
                      _vm.previousRequestedPackages,
                  },
                  on: {
                    "load-email-preview": _vm.handleLoadPreview,
                    valid: _vm.handleValid,
                    "select-email-request": _vm.handleSelectEmailRequest,
                    "include-send-application":
                      _vm.handleIncludeSendApplication,
                    "include-request-documents":
                      _vm.handleIncludeRequestDocuments,
                    "include-request-bank-statements":
                      _vm.handleIncludeBankStatements,
                    "change-application-details":
                      _vm.handleChangeApplicationDetails,
                    "select-document-request": _vm.handleSelectDocumentRequest,
                    "select-all-document-requests":
                      _vm.handleSelectAllDocumentRequests,
                    "change-selected-coapplicants":
                      _vm.handleChangeSelectedApplicants,
                    "add-bank-statement-request":
                      _vm.handleAddBankStatementRequest,
                    "delete-bank-statement-request":
                      _vm.handleDeleteBankStatementRequest,
                    "change-bank-months": _vm.handleChangeBankMonths,
                    "add-email-user-message": _vm.handleAddEmailUserMessage,
                    "update-email-template": _vm.handleUpdateEmailTemplate,
                    "delete-email-template": _vm.handleDeleteEmailTemplate,
                    "select-email-template": _vm.handleSelectEmailTemplate,
                    "create-email-template": _vm.handleCreateEmailTemplate,
                    "hide-modal": _vm.closeModal,
                  },
                }),
          ]
        },
        proxy: true,
      },
      {
        key: "footer",
        fn: function () {
          return [
            _vm.loadingInitialData
              ? _c("default-footer-loader", { staticClass: "w-100 h-100" })
              : _c("fragment", [
                  _c(
                    "div",
                    {
                      staticClass:
                        "steps-actions d-flex flex-row justify-content-around",
                      on: { click: _vm.checkForErrors },
                    },
                    [
                      _vm.showPreviousButton
                        ? _c(
                            "button",
                            {
                              ref: "previousButton",
                              staticClass: "btn btn-sm btn-white mr-2",
                              attrs: { type: "button" },
                              on: { click: _vm.previousStep },
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.previousButtonText) +
                                  "\n        "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "plan-simple-button",
                        {
                          attrs: {
                            id: "share-application-submit",
                            "class-name":
                              "btn-moregage btn-sm share-application",
                            placement: "topleft",
                            disabled: !_vm.isCurrentStepValid,
                            loading: _vm.sendingEmail.loading,
                            "loading-succeeded": _vm.sendingEmail.status,
                            page: _vm.accountPlanPage,
                          },
                          on: { click: _vm.handleSubmit },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.nextButtonText) +
                              "\n        "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ]),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }